import Vue from 'vue';

if (!window.isVueEventDefined) {
  window.Event = new class {
    constructor() {
      this.vue = new Vue();
      window.isVueEventDefined = true;
    }

    fire(event, data = null) {
      this.vue.$emit(event, data);
      const domEvent = document.createEvent('Event');
      domEvent.initEvent(event, true, true);
      window.dispatchEvent(domEvent);
    }

    listen(event, callback) {
      this.vue.$on(event, callback);
    }
  };
}

export default window.Event;
